import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import tw from 'tailwind.macro'
import { Heading, Wrapper, SubHeading, Paragraph, Head } from '@/shared/styled'
import { withPrefix } from 'gatsby'
import { FaPlayCircle, FaCircleNotch } from 'react-icons/fa'
import { MdClose } from 'react-icons/md'
import ReactDOM from 'react-dom'

const Container = styled.div`
  max-width: 1000px;
  margin: auto;
  ${tw`mt-18 px-5`};
`

const CardContainer = styled.div`
  border-radius: 20px;
  border: 1px solid ${props => props.theme.grey};
  background-color: ${props => props.theme.white};
  ${tw`sm:px-14 sm:py-12 p-10`};
`

const Avatar = styled.div`
  ${tw`bg-cover bg-center bg-no-repeat`};
  flex: 100px 0 0;
  width: 100px;
  height: 100px;
  background-image: url(${props => props.url});
`

const Card = ({ image, name, university, role, quote }) => (
  <CardContainer>
    <div className="flex sm:items-center sm:flex-row flex-col items-start mb-8">
      <Avatar url={withPrefix(image)} />
      <div className="sm:ml-8 ml-0 sm:mt-0 mt-6">
        <h5 className="text-xl font-semibold mb-2">{name}</h5>
        <p className="text-sm opacity-60">
          {university}
          <br />
          {role}
        </p>
      </div>
    </div>

    <Paragraph>{quote}</Paragraph>
  </CardContainer>
)

const members = [
  {
    name: 'Phat Nguyen',
    university: 'University of Science',
    role: 'Backend Developer',
    image: '/img/PhatNguyen@2x.png',
    quote:
      '“Interning at Dwarves Foundation was a once-in-a-lifetime experience. It complemented my skills and shaped my mindset since interns were considered as valuable members of the team. Such a privilege to learn from and work with these talented mentors.”',
  },
  {
    name: 'Khiem Vo',
    university: 'International University',
    role: 'Backend Developer',
    image: '/img/KhiemVo@2x.png',
    quote:
      'After finished the 3-month period, I decided to go for a full time position. I got to know how to start a production project, how to select a suitable technology to get things done. With all of those experiences coming up, Dwarves Foundation did give me a chance to step out of my comfort zone.”',
  },
]

const VideoBlock = styled.div`
  ${tw`relative mb-14 sm:block hidden`};
  font-size: 0;
  border-radius: 20px;
  overflow: hidden;
`

const PopupContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  color: white;
  background-color: rgba(0, 0, 0, 0.75);
`

const Overlay = styled.div`
  ${tw`absolute pin`};
  background-color: rgba(0, 0, 0, 0.15);
`

const PlayButton = styled.button`
  background: transparent;
  border: none;
  font-size: 80px;
  line-height: 1em;
  color: ${props => props.theme.white};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const Spin = keyframes`
  from {
      transform: rotate(0deg);
  }
  to {
      transform: rotate(359deg);
  }
`

const LoadingIcon = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: 50%;
  animation: ${Spin} 2s infinite linear;
  width: 24px;
  height: 24px;
  border: 3px solid white;
  border-left-color: transparent;
  border-radius: 9999px;
  ${tw`flex items-center justify-center`}
  display: ${props => (props.loading ? 'block' : 'none')}
`

const CloseButton = styled.button`
  border: none;
  background-color: transparent;
  font-size: 32px;
  top: 20px;
  right: 20px;
  position: absolute;
  color: white;
  padding: 0;
`

const IframeWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 80vw;
  transform: translate(-50%, -50%);

  > div {
    position: relative;
    padding-bottom: 56.25%; /*16:9*/
    height: 0;
    overflow: hidden;
    transition: all 0.4s ease;

    ${props =>
      props.loading
        ? `
    opacity: 0;
    transform: scale(0.8);      
    `
        : `
    opacity: 1;
    transform: scale(1);      
    `}
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const MobileVideoHolder = styled.div`
  ${tw`sm:hidden block`};
  padding-bottom: 56.6%;
  margin-bottom: 60px;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  border: 1px solid ${props => props.theme.grey};
  iframe {
    position: absolute;
    width: 104%;
    height: 104%;
    top: -2%;
    left: -2%;
  }
`

class VidePopup extends Component {
  state = {
    loading: true,
  }

  componentDidMount() {
    this.ref.onload = () => {
      this.setState({ loading: false })
    }
    // TODO: should be an UI for error
    this.ref.onerror = () => {
      this.setState({ loading: false })
    }

    document.addEventListener('keydown', this.closeByEsc)
  }

  closeByEsc = e => {
    if (e.key === 'Escape') {
      this.close()
      document.removeEventListener('keydown', this.closeByEsc)
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.closeByEsc)
  }

  close = () => {
    this.props.onClose()
  }

  render() {
    return (
      <PopupContainer>
        <IframeWrapper loading={this.state.loading}>
          <div>
            <iframe
              ref={node => (this.ref = node)}
              src={this.props.link}
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </IframeWrapper>
        <LoadingIcon loading={this.state.loading} />
        <CloseButton onClick={this.close} aria-label="close video popup">
          <MdClose />
        </CloseButton>
      </PopupContainer>
    )
  }
}

const AlumniSection = () => {
  let holder
  const openVideo = () => {
    holder = document.createElement('div')
    document.body.appendChild(holder)
    ReactDOM.render(
      <VidePopup
        link={
          'https://www.youtube.com/embed/FWW6hve0GR8?rel=0;&autoplay=1&mute=1'
        }
        onClose={closeVideo}
      />,
      holder
    )
  }

  const closeVideo = () => {
    if (holder) {
      document.body.removeChild(holder)
      holder = undefined
    }
  }

  return (
    <section className="sm:pt-24 sm:pb-14 pt-14 pb-0" id="alumni">
      <Wrapper>
        <Head>
          <Heading>Our Alumni</Heading>
          <Paragraph>Take a look at our latest program.</Paragraph>
        </Head>
      </Wrapper>

      <Container>
        <VideoBlock>
          <img
            src={withPrefix('/img/Banner.png')}
            srcSet={`${withPrefix('/img/Banner@2x.png')} 2x`}
            alt="Internship 2018 summary"
          />
          <Overlay />
          <PlayButton onClick={openVideo}>
            <FaPlayCircle />
          </PlayButton>
        </VideoBlock>

        <MobileVideoHolder>
          <iframe
            src={'https://www.youtube.com/embed/FWW6hve0GR8'}
            frameBorder="0"
            allowFullScreen
          />
        </MobileVideoHolder>

        <div className="-mx-5 flex flex-wrap">
          {members.map((member, index) => (
            <div className="lg:w-1/2 w-full mb-10 px-5 flex" key={index}>
              <Card {...member} />
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default AlumniSection
